import type { NetworkType } from "./general.types";

export type BridgeRouteStep = {
  step: number | string;
  txHash: string;
};

export enum BSFilterParamEnum {
  TransferType = "types",
  SourceChain = "fromChains",
  TargetChain = "toChains",
  Address = "address",
  FromDate = "from_timestamp",
  ToDate = "to_timestamp",
  Cursor = "cursor",
}

export enum BSFilterTypeEnum {
  BLESS = "BLESS",
  ERC20 = "ERC20",
  ERC721 = "ERC721",
  ERC1155 = "ERC1155",
  TXN = "TXN",
  DSPNSR = "DSPNSR",
}

export enum TransactionStatusEnum {
  Done = "done",
  WaitForWormholeComplete = "wait-wh",
  WaitForRollupBridge = "wait-rb",
  WaitForChildChainConfirmation = "wait-cc",
  Manual = "manual",
  Error = "error",
  WaitForDispenser = "wait-dsp",
}

export type Transaction = {
  network: NetworkType;
  _id: string;
  originTimestamp?: number | string;
  type?: BSFilterTypeEnum;
  bless?: string;
  chainType?: string;
  status?: TransactionStatusEnum;
  fromChain?: number;
  toChain?: number;
  fromAddress?: string;
  toAddress?: string;
  tokenIds?: string[];
  tokenContract?: string;
  tokenAmount?: string;
  tokenAmounts?: string[];
  tokenSymbol?: string;
  originTxnHash?: string;
  rbTxnHash?: string; // Optional as it's missing in one entry
  whTxnHash?: string;
  deliveryTxnHash?: string;
  route?: BridgeRouteStep[];
  calldata?: string;
  targetContract?: string;
};

export type BridgeResponse = {
  bridgeData: Transaction[];
  nextCursor: string | null;
};

export enum TransactionRouteStep {
  Wormhole = "wormhole",
  RollupBridge = "rollup-bridge",
  ChildChain = "child-chain",
  Delivery = "delivery",
}

export type DateRangeFilter = [Date | null, Date | null];
export type SearchParams = Map<string, string[]>;
